import React, { useState, useEffect } from 'react';
import './HeatingOnSwitch.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faRobot, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons';

const config = require('../config');

const HeatingOnSwitch = ({ header, measurement, addMeasurementToGraph, heatingOn }) => {
  const [isGraphSelected, setIsGraphSelected] = useState(false); 
  const [isOn, setIsOn] = useState(heatingOn === 2);
  const [isAutomatic, setIsAutomatic] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    setIsOn(heatingOn === 2);
  }, [heatingOn]);

  useEffect(() => {
    fetch(config.serverUrl + '/heating-value?env=smedsby&name=SmedsbyHeatingAutomatic',  {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          })
          .then(response => response.json())
          .then(data => setIsAutomatic(data.value === 1));
  }, [measurement, token]);

  const toggleAutomatic = () => {
    const newValue = !isAutomatic;
    setIsAutomatic(newValue);
    
    fetch(config.serverUrl + '/heating-value', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            "env": "smedsby",
            "name": "SmedsbyHeatingAutomatic",
            "value": newValue ? 1 : 0
          })
        })
        .catch(error => { console.log(error); });
  };

  const toggleOnOff = () => {
    const newValue = !isOn;
    setIsOn(newValue);

    fetch(config.serverUrl + '/smedsby-thermia-heatingon',  {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        "value": newValue ? 2 : 0
      })
    })
    .catch(error => { console.log(error); });
  };

  const handleAddMeasurementToGraph = () => {
    console.log('Button clicked');
    setIsGraphSelected(!isGraphSelected);
    addMeasurementToGraph(header, measurement, 'temp');
  };

  return (
    <div className="input-container">
      <span className="heatingon-header">{header}</span>
      <button onClick={toggleAutomatic} className="isAutomatic">
        <FontAwesomeIcon icon={faRobot} color={isAutomatic ? 'green' : 'red'} />
      </button>
      <button onClick={toggleOnOff} className="toggleonoff-button">
        <FontAwesomeIcon icon={isOn ? faToggleOn : faToggleOff} color={isOn ? 'green' : 'red'} />
      </button>
      <button onClick={handleAddMeasurementToGraph} className={isGraphSelected ? 'graph-btn-selected' : 'graph-btn'}>
        <FontAwesomeIcon icon={faChartLine} />
      </button>
    </div>
  );
};

export default HeatingOnSwitch;
